import { render, staticRenderFns } from "./AIInteraction.vue?vue&type=template&id=b61327e2&scoped=true"
import script from "./AIInteraction.vue?vue&type=script&lang=js"
export * from "./AIInteraction.vue?vue&type=script&lang=js"
import style0 from "./AIInteraction.vue?vue&type=style&index=0&id=b61327e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61327e2",
  null
  
)

export default component.exports